import { Slide } from '@mui/material'
import React, { useContext, useEffect, useRef } from 'react'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import { InputProcessingLoader } from '@f/applications/QuizApp/partials/InputProcessingLoader'
import { STEP_TRANSITION_DURATION } from '@f/applications/QuizApp/partials/quizConstants'
import { QuizStep } from '@f/applications/QuizApp/partials/types'
import { useUrlStepTracker } from '@f/applications/QuizApp/partials/useUrlStepTracker'

import { $TSFixMe } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

interface StepTransitionProps {
  currentStep: QuizStep
  children: React.ReactNode
}

export const QuizStepTransition = ({
  currentStep,
  children
}: StepTransitionProps) => {
  const {
    data: { stepIndex, steps },
    actions: { move },
    displayStep,
    displayLoader
  } = useContext(QuizContext) as $TSFixMe
  const memoizedStep = useRef(currentStep)

  useEffect(() => {
    if (currentStep.id !== memoizedStep.current.id) {
      memoizedStep.current = currentStep
    }
  }, [currentStep])

  useUrlStepTracker({
    stepIndex,
    triggerStepForward: () => move({ to: 'next' }),
    triggerStepBackward: () => move({ to: 'prev' }),
    isTransitioningBetweenSteps: currentStep.displayTransition
  })

  const currentStepId = steps.findIndex(step => step.id === currentStep.id)
  const previousStepId = steps.findIndex(
    step => step.id === memoizedStep.current.id
  )

  return (
    <>
      {displayLoader && <InputProcessingLoader />}
      <Slide
        in={displayStep}
        timeout={STEP_TRANSITION_DURATION}
        appear={false}
        direction={
          displayStep && currentStepId !== previousStepId ? 'left' : 'right'
        }>
        <div className='QuizApp-step QuizApp-wrap is-active'>{children}</div>
      </Slide>
    </>
  )
}
